import classNames from "classnames";
import "sass/components/Section.scss";

type SectionProps = {
  children: React.ReactNode;
  isFirst: boolean;
  name: String;
};

function Section({ children, isFirst, name }: SectionProps) {
  return (
    <div className={classNames("section", { first: isFirst }, name)}>
      <div className="section-body">{children}</div>
    </div>
  );
}

Section.defaultProps = {
  isFirst: false,
};

export default Section;
